import React from 'react';

import { ADMIN_REPORTS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';

const CreateOrEditReportsPage = React.lazy(() =>
  import('../../../pages/Admin/Reports/CreateOrEditReports/CreateOrEditReportPage'),
);

export default [
  {
    group: ADMIN,
    to: '/administration/new-report/:reportType',
    route: '/administration/new-report/:reportType',
    component: CreateOrEditReportsPage,
    hasNavBar: true,
    adminVisibilityPermission: ADMIN_REPORTS,
    area: ADMIN_REPORTS,
    requiredRoles: ['admin', 'super_admin'],
  },
  {
    group: ADMIN,
    to: '/administration/edit-report/:reportType/:reportId',
    route: '/administration/edit-report/:reportType/:reportId',
    component: CreateOrEditReportsPage,
    hasNavBar: true,
    adminVisibilityPermission: ADMIN_REPORTS,
    area: ADMIN_REPORTS,
    requiredRoles: ['admin', 'super_admin'],
  },
];
